import { render, staticRenderFns } from "./FloatingScrollbar.vue?vue&type=template&id=9160e5ca&scoped=true&"
import script from "./FloatingScrollbar.vue?vue&type=script&lang=ts&"
export * from "./FloatingScrollbar.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingScrollbar.vue?vue&type=style&index=0&id=9160e5ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9160e5ca",
  null
  
)

export default component.exports